import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSessionContext } from '@contexts';

const HomeSelector = () => {

    const navigate = useNavigate();
    const { session } = useSessionContext();

    useEffect(() => {
        if (session.isGuarantor) {
            navigate(`/guarantor`);
        } else {
            navigate(`/payor`);
        }
    }, []);

    return (
        <div></div>
    );
};

export default HomeSelector;
